import './styles/global.scss'
import Routes from "./routes";

export function App() {
  return <Routes/>;
}